import React from 'react';
import { IconProps } from '.';

const SvgScreenNormal = ({
  size = 16,
  color = '#292B2B',
  secondaryColor = '#B3BABD',
  className,
  ...props
}: IconProps): JSX.Element => {
  return (
    <svg
      width={size}
      height={size}
      fill='none'
      viewBox='0 0 24 24'
      className={className ? 'pds-icon ' + className : 'pds-icon'}
      {...props}
    >
      <path
        fill={color}
        fillRule='evenodd'
        d='M10 4.75V4H8.5v4.5H4V10h6V4.75ZM4.75 14H4v1.5h4.5V20H10v-6H4.75ZM15.5 4v4.5H20V10h-6V4h1.5Zm-.75 10H14v6h1.5v-4.5H20V14h-5.25Z'
        clipRule='evenodd'
      />
    </svg>
  );
};

export default SvgScreenNormal;
